module.exports = __webpack_public_path__ + "img/mdtn-studio.9c17e0c.svg";